(function () {
  if (window.deferredCardImagesInitialized) return;
  window.deferredCardImagesInitialized = true;

  var imageSelector = '.js-deferred-card-image';
  var interactionSelector = '.js-deferred-card-image--interaction';

  function loadImage(image) {
    if (!image || image.dataset.deferredLoaded === 'true') return;

    if (image.dataset.srcset) {
      image.setAttribute('srcset', image.dataset.srcset);
      image.removeAttribute('data-srcset');
    }

    if (image.dataset.src) {
      image.setAttribute('src', image.dataset.src);
      image.removeAttribute('data-src');
    }

    image.dataset.deferredLoaded = 'true';
  }

  function bindInteractionImage(image) {
    if (!image || image.dataset.deferredInteractionBound === 'true') return;

    var card = image.closest('.card-wrapper') || image.closest('.grid__item') || image.parentElement;
    if (!card) return;

    var load = function () {
      loadImage(image);
    };

    image.dataset.deferredInteractionBound = 'true';
    card.addEventListener('mouseenter', load, { once: true, passive: true });
    card.addEventListener('focusin', load, { once: true });
    card.addEventListener('pointerdown', load, { once: true, passive: true });
    card.addEventListener('touchstart', load, { once: true, passive: true });
  }

  function setupDeferredImages() {
    var images = Array.prototype.slice.call(document.querySelectorAll(imageSelector));

    if (!images.length) return;

    images.forEach(function (image) {
      if (image.matches(interactionSelector)) {
        bindInteractionImage(image);
      }
    });

    var primaryImages = images.filter(function (image) {
      return !image.matches(interactionSelector) && image.dataset.deferredObserved !== 'true';
    });

    if (!primaryImages.length) return;

    if (!('IntersectionObserver' in window)) {
      primaryImages.forEach(loadImage);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px 100px 0px' }
    );

    primaryImages.forEach(function (image) {
      image.dataset.deferredObserved = 'true';
      observer.observe(image);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDeferredImages);
  } else {
    setupDeferredImages();
  }

  document.addEventListener('shopify:section:load', setupDeferredImages);
})();
